import React, { Component } from "react";
import ButtonView from "../../../../../../components/Button/ButtonView";
import PaginatedDialogFooterViewProps from './PaginatedDialogFooterViewProps';
import PaginatedDialogFooterViewStyle from './PaginatedDialogFooterViewStyle';
import PaginatedDialogFooterViewState from "./PaginatedDialogFooterViewState";
import Color from "../../../../../../../models/constants/Color";
import App from "../../../../../../App";

export default class PaginatedDialogFooterView extends Component<PaginatedDialogFooterViewProps, PaginatedDialogFooterViewState> {

    private _style: PaginatedDialogFooterViewStyle;

    constructor(props: PaginatedDialogFooterViewProps) {
        super(props);

        this.state = { isBusy: false };

        this._style = new PaginatedDialogFooterViewStyle();
    }

    private _onBackClick = () => {
        App._history.goBack();
    }

    private _onSubmitClick = () => {
        this.setState({ isBusy: true }, () => {
            this.props.onSubmit(() => {
                this.setState({ isBusy: false });
            });
        });
    }

    private _renderBulletPoints = () => {
        let points = [];
        for (let i = 0; i < this.props.numberOfPages; i++) {
            const active = i + 1 <= this.props.currentPage;
            points.push(
                <div key={i} style={{ ...this._style.bulletPoint, backgroundColor: active ? Color.Primary : 'white' }} />
            );
        }

        return points;
    }

    render() {

        // Destruct
        const { currentPage } = this.props;

        return (
            <div style={this._style.footer}>
                {currentPage > 1 ?
                    (
                        <ButtonView theme="secondary" width={100} isBusy={false} onClick={this._onBackClick}>
                            {this.props.backButtonText || 'back'}
                        </ButtonView>
                    )
                    :
                    (
                        <div style={{width:120}} />
                    )
                }

                <div style={this._style.bullets}>
                    {this._renderBulletPoints()}
                </div>

                <ButtonView theme="primary" width={100} isBusy={this.state.isBusy} onClick={this._onSubmitClick}>
                    {this.props.submitButtonText || 'next'}
                </ButtonView>
            </div>
        );
    }
}